module.exports = __webpack_public_path__ + "static/img/9.4a1f50b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/9.png
// module id = re0p
// module chunks = 0